<template>
  <div class="page-wrapper">
    <h1>Договора</h1>

    <div v-if="projectFetched">
      <div v-if="!ownerId">
        Для работы с договорами необходимо указать
        <router-link :to="`/projects/${ this.$route.params.id }#client`">клиента</router-link>
      </div>

      <div v-else-if="!isPaymentsDataFilled">
        Для работы с договорами необходимо
        <router-link :to="`/projects/${ this.$route.params.id }/requisites`">заполнить реквизиты проекта
        </router-link>
      </div>

      <div v-else>
        <q-btn
            @click="generateLicenseWithContract()"
            color="primary"
            label="сгенерировать персональный договор"
            class="q-mt-lg"
        />

        <create-document-modal
            :opened="this.showDocumentModal"
            @closed="closeModal"
        />

        <documents-list/>
      </div>
    </div>

    <div class="loader row justify-center" v-else>
      <q-spinner-mat size="100px" style="color: #C1DDF5FF"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import DocumentsList from '@/DocumentsList'
import { QBtn, QSpinnerMat } from 'quasar'
import CreateDocumentModal from "../components/ProjectDocuments/CreateDocumentModal.vue";

export default {
  name: 'ProjectDocumentsView',

  components: {
    CreateDocumentModal,
    DocumentsList,
    QBtn,
    QSpinnerMat,
  },

  data () {
    return {
      showDocumentModal: false,
    }
  },

  computed: {
    ...mapState('project', {
      paymentsData: 'requisites',
    }),

    ...mapGetters('project', {
      projectFetched: 'fetched',
      ownerId: 'ownerId',
      requisites: 'requisites',
    }),

    isPaymentsDataFilled () {
      return this.paymentsData.edrpou && this.paymentsData.company_type
    },
  },

  methods: {
    fetchDocuments () {
      this.$store.dispatch('project/fetchDocuments', this.$route.params.id)
    },

    closeModal(){
      this.showDocumentModal = false
      this.fetchDocuments()
    },

    generateLicenseWithContract () {
      this.showDocumentModal = true
    },
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/ProjectDocumentsView.vue